import React, { useEffect, useState } from 'react';
import { Button, Table } from '@/components/Elements';
import TableLoader from '@/components/Elements/Loader/TableLoader';
import close from '@/assets/close-circle.svg';
import { useNavigate } from 'react-router-dom';
import { LawyerContractList } from '../../types/LawyerContractList';
import Modal from 'react-responsive-modal';
import { useNotificationStore } from '@/stores/notifications';
import { acceptOrRejectLawyerRequest } from '../../api/finalizeLawyer';
import { useLawyerRequests } from '../../api/getLawyerRequests';
import { Form } from '@/components/Form/Form';
import { InputField } from '@/components/Form/InputField';
import { sendConractLawyer } from '../../api/submitContract';
import { DocUploader } from '@/components/Elements/upload/DocUploader';

type FormValues = {
  company_name: string;
  full_name: string;
};

const AllRequestsList = ({
  page,
  changePage,
}: {
  page: string;
  changePage: (page: string) => void;
}) => {
  const { data, refetch, isLoading, isFetching } = useLawyerRequests({});
  const [id, setId] = useState<any>();
  const [open, setOpen] = useState(false);
  const [media, setMedia] = useState({
    contract_file: '',
  });

  const [mediaError, setMediaError] = useState({
    contract_file: false,
  });
  const [customerId, setCustomerId] = useState();
  const navigate = useNavigate();

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const handleMediaChange = (value: string, type: string) => {
    setMedia((prevMedia) => ({
      ...prevMedia,
      [type]: value,
    }));
  };

  useEffect(() => {
    refetch();
  }, [page, refetch]);

  const handleModal = (id: number, customer_id: number) => {
    onOpenModal();
    setId(id);
    setCustomerId(customer_id);
  };

  const handleSubmit = async (values) => {
    if (media?.contract_file === '') {
      const updatedError = { ...mediaError, contract_file: true };
      setMediaError(updatedError);
      return;
    }
    await sendConractLawyer({
      property_id: id,
      ...values,
      customer_id: customerId,
      contract_file: media?.contract_file,
    });
    useNotificationStore.getState().addNotification({
      type: 'success',
      title: 'Success',
      message: 'Contract form submitted successfully!',
    });
    onCloseModal();
    refetch();
  };

  const handleAcceptOrReject = async (req_status, property_id) => {
    try {
      await acceptOrRejectLawyerRequest({ req_status, property_id });
      useNotificationStore.getState().addNotification({
        type: 'success',
        title: 'Succes',
        message: 'Offer Accepted !',
      });
      refetch();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isLoading || isFetching ? (
        <TableLoader />
      ) : (
        <Table<LawyerContractList>
          page={parseInt(page)}
          changePage={changePage}
          total={data?.total ?? 1}
          data={data?.data ?? []}
          columns={[
            {
              title: 'Inquiry Customer Name',
              field: 'name',
              Cell({ entry: { name } }) {
                return <span>{name}</span>;
              },
            },
            { title: 'Inquiry Customer Email', field: 'email' },
            { title: 'Inquiry Customer No.', field: 'mobile_number' },
            {
              title: 'Action',
              field: 'id',
              Cell({ entry: { id, req_status, customer_id } }) {
                return (
                  <div className="d-flex gap-2">
                    {req_status === 'pending' ? (
                      <div className="d-flex gap-2">
                        <Button onClick={() => handleAcceptOrReject('accepted', id)}>Accept</Button>
                        <Button onClick={() => handleAcceptOrReject('rejected', id)}>
                          Rejected
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button>
                          {req_status === 'accepted' ? (
                            <span onClick={() => handleModal(id, customer_id)}>Send Contract</span>
                          ) : (
                            <span>{req_status}</span>
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                );
              },
            },
          ]}
        />
      )}

      <div className="agency-modal">
        <Modal open={open} onClose={onCloseModal} center>
          <button
            className="modal-close-button"
            onClick={onCloseModal}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '40px',
              cursor: 'pointer',
            }}
          >
            <img src={close} className="close-circle" />
          </button>

          <section className="agency-model">
            <h5 className="agency-title semi-bold text-black">Contract</h5>

            {/* Contract Form */}
            <Form<FormValues>
              id="contract-form"
              onSubmit={async (values) => {
                console.log('Submitting contract form for id:', id, values);
                handleSubmit(values);
              }}
            >
              {({ register, formState }) => (
                <>
                  <InputField
                    label="Company Name"
                    error={formState.errors['company_name']}
                    registration={register('company_name', {
                      required: 'Company name is required',
                    })}
                  />
                  <InputField
                    label="Full Name"
                    error={formState.errors['full_name']}
                    registration={register('full_name', {
                      required: 'Full name is required',
                    })}
                  />
                  <DocUploader
                    src={media?.contract_file}
                    setImage={(img) => handleMediaChange(img, 'contract_file')}
                    labbel="Contract File"
                    placeholder="Upload Document"
                    error={mediaError?.contract_file}
                    // error={formState.errors['foundation']?.message}
                  />

                  <div className="sub-btns d-flex gap-3 mt-4 align-items-center justify-left">
                    <Button form="contract-form" type="submit" className="rounded-full pink-btn">
                      Submit
                    </Button>
                  </div>
                </>
              )}
            </Form>
          </section>
        </Modal>
      </div>
    </>
  );
};

export default AllRequestsList;
